import React, { useEffect, useState, useRef } from 'react';
import { useThree, useFrame } from '@react-three/fiber';
import { PerspectiveCamera } from '@react-three/drei';
import { Object3D, MeshPhysicalMaterial, Vector3, Fog as _Fog, Euler } from 'three';
import { a } from '@react-spring/three';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
const url = 'https://raw.githubusercontent.com/iondrimba/images/master/buildings.obj';
const loader = new OBJLoader();
const color = '#353c3c';
const CityFog = (props) => {
    var _a, _b;
    const [group, setGroup] = useState();
    const buildingRef = useRef([]);
    const { scene } = useThree();
    useEffect(() => {
        loader.load(props.url || url, (obj) => {
            obj.castShadow = true;
            obj.receiveShadow = true;
            const models = [...obj.children].map((model) => {
                const scale = 0.01;
                model.scale.set(scale, scale, scale);
                model.receiveShadow = true;
                model.castShadow = true;
                return model;
            });
            const boxSize = 3;
            const meshParams = {
                metalness: 0,
                roughness: 0.77,
            };
            const max = 0.009;
            const min = 0.001;
            const material = new MeshPhysicalMaterial(Object.assign(Object.assign({}, meshParams), { transparent: true }));
            const buildings = new Object3D();
            const gridSize = 40;
            for (let i = 0; i < gridSize; i++) {
                for (let j = 0; j < gridSize; j++) {
                    const model = models[Math.floor(Math.random() * Math.floor(models.length))].clone();
                    model.material = material;
                    model.scale.y = Math.random() * (max - min + 0.01);
                    model.position.x = i * boxSize;
                    model.position.z = j * boxSize;
                    buildingRef.current.push(model);
                    buildings.add(model);
                }
            }
            buildings.castShadow = true;
            buildings.receiveShadow = true;
            setGroup(buildings);
        });
    }, []);
    useFrame(() => {
        var _a, _b;
        const near = 1;
        const far = 208 * ((_b = (_a = props.style) === null || _a === void 0 ? void 0 : _a.opacity.get()) !== null && _b !== void 0 ? _b : 0);
        scene.fog = new _Fog(color, near, far);
        if (buildingRef.current) {
            buildingRef.current.forEach((building) => {
                var _a, _b, _c;
                building.material.opacity = ((_a = props.p) === null || _a === void 0 ? void 0 : _a.phase) === 'leave' ? 0 : (_c = (_b = props.style) === null || _b === void 0 ? void 0 : _b.opacity.get()) !== null && _c !== void 0 ? _c : 1;
            });
        }
    });
    const scale = (_a = props.style) === null || _a === void 0 ? void 0 : _a.scale.to([0, 1], [0.8, 1]);
    return (React.createElement(a.group, { scale: scale },
        React.createElement(a.mesh, { "material-opacity": (_b = props.style) === null || _b === void 0 ? void 0 : _b.opacity }, group ? (React.createElement("primitive", { castShadow: true, receiveShadow: true, object: group, dispose: null })) : null)));
};
const rotation = [-0.4239391588266323, 0.7010640463834621, 0.2832774959276831];
const position = [127.45293777867074, 62.11080512264083, 137.6247069251716];
export const FogCamera = () => {
    return (React.createElement(PerspectiveCamera, { rotation: new Euler(...rotation), position: new Vector3(...position), makeDefault: true, args: [20, 2, 1, 1000] }));
};
const Fog = (props) => {
    var _a, _b;
    return (React.createElement(a.group, null,
        React.createElement(CityFog, { style: props.style, p: props.p, url: props.url }),
        React.createElement("directionalLight", { position: [-8, 12, 0], castShadow: true, color: "#272727" }),
        React.createElement("directionalLight", { position: [8, 1200, 8], color: "#d3263a", castShadow: true }),
        React.createElement(a.mesh, { "material-opacity": (_a = props.style) === null || _a === void 0 ? void 0 : _a.opacity, rotation: [0, 0, -Math.PI / 2], position: [0, 0, 0] },
            React.createElement("planeBufferGeometry", { attach: "geometry", args: [400, 400] }),
            React.createElement("meshPhysicalMaterial", { transparent: true, attach: "material", color: color })),
        React.createElement(a.mesh, { "material-opacity": (_b = props.style) === null || _b === void 0 ? void 0 : _b.opacity, castShadow: true, receiveShadow: true, rotation: [-Math.PI / 2, 0, 0], position: [50, 0, 50] },
            React.createElement("planeBufferGeometry", { attach: "geometry", args: [100, 100, 10, 10] }),
            React.createElement("meshPhysicalMaterial", { transparent: true, attach: "material", color: color }))));
};
export default Fog;
